import db from "../driverappdb";

export const EnumTranslationRepository = {
    get: async (enumTranslationType, enumValue) => {
        return await db.enumtranslations.where({ type: enumTranslationType, value: enumValue }).first();
    },
    getAll: async (enumTranslationType) => {
        return await db.enumtranslations.where({ type: enumTranslationType }).toArray();
    }
};